export default interface IBcryptOptions {
  saltRounds?: number;
};
